<script lang="ts">
  import { SUBSCRIPTION_LIMITS, PRICING_PLANS } from '$lib/constants/subscription';
</script>

<div class="comparison-table">
  <table>
    <thead>
      <tr>
        <th class="feature-col">
          <div class="header-content">기능</div>
        </th>
        <th class="plan-col">
          <div class="header-content">무료</div>
        </th>
        <th class="plan-col premium">
          <div class="header-content">프리미엄</div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="feature-cell">
          <div class="feature-content">
            <span class="feature-name">텍스트 길이 제한</span>
            <span class="feature-desc">한 번에 검사할 수 있는 최대 글자 수</span>
          </div>
        </td>
        <td class="value-cell">{SUBSCRIPTION_LIMITS.FREE.maxTextLength.toLocaleString()}자</td>
        <td class="value-cell premium">{SUBSCRIPTION_LIMITS.PREMIUM.maxTextLength.toLocaleString()}자</td>
      </tr>
      
      <tr>
        <td class="feature-cell">
          <div class="feature-content">
            <span class="feature-name">맞춤법 검사 제한</span>
            <span class="feature-desc">하루 동안 사용 가능한 맞춤법 검사 횟수</span>
          </div>
        </td>
        <td class="value-cell">{SUBSCRIPTION_LIMITS.FREE.dailySpellCheckLimit}회</td>
        <td class="value-cell premium">
          {SUBSCRIPTION_LIMITS.PREMIUM.dailySpellCheckLimit === -1 ? '무제한' : `${SUBSCRIPTION_LIMITS.PREMIUM.dailySpellCheckLimit}회`}
        </td>
      </tr>

      <tr>
        <td class="feature-cell">
          <div class="feature-content">
            <span class="feature-name">AI 분석</span>
            <span class="feature-desc">AI를 활용한 문장 분석</span>
          </div>
        </td>
        <td class="value-cell">{SUBSCRIPTION_LIMITS.FREE.dailyAIAnalysisLimit}회/일</td>
        <td class="value-cell premium">{SUBSCRIPTION_LIMITS.PREMIUM.dailyAIAnalysisLimit.toLocaleString()}회/일</td>
      </tr>

      <tr>
        <td class="feature-cell">
          <div class="feature-content">
            <span class="feature-name">본인 API 키 사용 (BYOK)</span>
            <span class="feature-desc">GPT-4, Claude, Gemini 등 무제한 사용</span>
          </div>
        </td>
        <td class="value-cell">지원</td>
        <td class="value-cell premium">지원</td>
      </tr>
      
      <tr class="price-row">
        <td class="feature-cell">
          <div class="feature-content">
            <span class="feature-name">가격</span>
            <span class="feature-desc">구독 요금</span>
          </div>
        </td>
        <td class="value-cell">무료</td>
        <td class="value-cell premium">
          <div class="price-options">
            <span class="price-text">월 ${PRICING_PLANS.PREMIUM_MONTHLY.price}</span>
            <span class="price-divider">|</span>
            <span class="price-text">연 ${PRICING_PLANS.PREMIUM_YEARLY.price}</span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<style>
  .comparison-table {
    overflow-x: auto;
    border: 1px solid var(--border-primary);
    border-radius: 12px;
    background: var(--bg-secondary);
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
  }
  
  thead {
    background: var(--bg-tertiary);
    border-bottom: 2px solid var(--border-primary);
  }
  
  th {
    padding: 12px 16px;
    text-align: left;
    font-size: 12px;
    font-weight: 600;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  th.plan-col {
    text-align: center;
    min-width: 120px;
  }
  
  th.plan-col.premium {
    background: linear-gradient(135deg, rgba(139, 92, 246, 0.05), rgba(99, 102, 241, 0.05));
    color: var(--accent-primary);
  }
  
  .header-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }
  
  th.feature-col .header-content {
    justify-content: flex-start;
  }
  
  tbody tr {
    border-bottom: 1px solid var(--border-secondary);
    transition: background 0.2s;
  }
  
  tbody tr:hover {
    background: var(--bg-tertiary);
  }
  
  tbody tr:last-child {
    border-bottom: none;
  }
  
  td {
    padding: 14px 16px;
    font-size: 13px;
  }
  
  .feature-cell {
    color: var(--text-primary);
  }
  
  .feature-content {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  
  .feature-name {
    font-weight: 500;
    color: var(--text-primary);
  }
  
  .feature-desc {
    font-size: 12px;
    color: var(--text-tertiary);
  }
  
  .value-cell {
    text-align: center;
    color: var(--text-secondary);
  }
  
  .value-cell.premium {
    font-weight: 600;
    color: var(--accent-primary);
    background: linear-gradient(135deg, rgba(139, 92, 246, 0.05), rgba(99, 102, 241, 0.05));
  }
  
  .price-row {
    background: var(--bg-tertiary);
    font-weight: 600;
  }
  
  .price-row td {
    padding: 16px;
  }
  
  .price-options {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
  
  .price-text {
    font-size: 14px;
    font-weight: 600;
  }
  
  .price-divider {
    color: var(--border-secondary);
  }
  
  @media (max-width: 640px) {
    th, td {
      padding: 10px 12px;
      font-size: 12px;
    }
    
    .feature-name {
      font-size: 12px;
    }
    
    .feature-desc {
      font-size: 11px;
    }
  }
</style>